// Titles ~50-60 characters, descriptions ~140-160. Adjust the shop copy to what you really sell.
export const PAGE_SEO = {
  home: {
    title: "MajiMaji Hub | Borehole Drilling & Solar in Kenya & East Africa",
    description:
      "MajiMaji Hub drills boreholes and installs pumps and solar systems for homes, farms and businesses. Based in Thika, serving Kenya. Get a free quote.",
  },
  services: {
    title: "Borehole Drilling, Pumps & Solar Services | MajiMaji Hub",
    description:
      "Water surveys, borehole drilling, pump installation, solar systems and solar water pumping, plus maintenance and repairs. Request a quote from MajiMaji Hub.",
  },
  about: {
    title: "About MajiMaji Hub | Water & Solar Specialists in Thika",
    description:
      "Meet MajiMaji Hub, a Thika-based team delivering boreholes, pumps and solar systems for homes, farms and businesses across Kenya. See how we work.",
  },
  shop: {
    title: "Water & Solar Equipment Shop | MajiMaji Hub",
    description:
      "Browse pumps, solar equipment and water accessories from MajiMaji Hub in Thika, Kenya. Ask for a quote or order on WhatsApp.", // TODO: match the real catalogue
  },
  notFound: {
    title: "Page not found | MajiMaji Hub",
    description: "This page could not be found. Visit the MajiMaji Hub homepage.",
  },
};